"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = exports.RequiredWrapper = exports.RedText = exports.CancelSubscriptionButton = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
exports.CancelSubscriptionButton = styled_components_1.default.button `
	color: ${props => props.theme.color.gray7};
	border: none;
	text-decoration: underline;
	cursor: pointer;
	transition: all 0.167s ease;
	&:hover {
		opacity: 0.8;
	}
`;
exports.RedText = styled_components_1.default.span `
	color: #f6512c;
	line-height: 1;
	content: '*';
	font-size: 14px;
	font-family: SimSun, sans-serif;
	margin-right: 4px;
	display: inline-block;
`;
exports.RequiredWrapper = styled_components_1.default.div `
	padding-top: 2rem;
	margin-top: 2rem;
	border-top: 1px solid ${({ theme }) => theme.color.gray3};
	text-align: center;
	display: flex;
	justify-content: center;
`;
exports.EmailInput = (0, styled_components_1.default)(elements_1.Input) `
	max-width: 300px;
`;
